import { Box, Divider } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { isValid } from "date-fns";
import { useTranslation } from "react-i18next";
import { Heading1, Heading2, Text1, Text2 } from "../styled";
import { useFormContext } from "react-hook-form";

interface Props {
  tesName: string;
}

function Details({ tesName }: Props) {
  const { t } = useTranslation();

  const { watch } = useFormContext();
  const {
    workLocation,
    shortWorkTimeDescriptionFi,
    longWorkTimeDescriptionFi,
    workDescriptionFi,
    workStarts,
    workEnds,
    type,
    reasonForTemporaryEmployment,
  } = watch();

  // Format dates to dd.MM.yyyy
  const formattedWorkStarts =
    workStarts && isValid(workStarts)
      ? new Date(workStarts).toLocaleDateString("fi-FI")
      : "";
  const formattedWorkEnds =
    workEnds && isValid(workEnds)
      ? new Date(workEnds).toLocaleDateString("fi-FI")
      : "";

  return (
    <>
      <Box
        sx={{
          padding: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "8px",
          }}
        >
          <CalendarTodayIcon
            sx={{ minWidth: "30px", marginRight: "8px" }}
            fontSize="small"
          />
          {type === "Continuous" ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginTop: "-2px",
              }}
            >
              <Heading2>{t("order:continuousType")}</Heading2>
              <Heading2>
                {formattedWorkStarts
                  ? `${t("order:startDate")}: ${formattedWorkStarts}`
                  : ""}
              </Heading2>
            </Box>
          ) : (
            <Heading2>
              {`${t("order:fixedTermType")} ${formattedWorkStarts} ${formattedWorkStarts || formattedWorkEnds ? "-" : ""} ${formattedWorkEnds}`}
            </Heading2>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "8px",
          }}
        >
          <AccessTimeIcon
            sx={{ minWidth: "30px", marginRight: "8px" }}
            fontSize="small"
          />
          <Heading2>{shortWorkTimeDescriptionFi}</Heading2>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <LocationOnIcon
            sx={{ minWidth: "30px", marginRight: "8px" }}
            fontSize="small"
          />
          <Heading2>
            {workLocation?.address?.street &&
            workLocation?.address?.zip &&
            workLocation?.address?.city
              ? `${workLocation?.address?.street}, ${workLocation?.address?.zip} ${workLocation?.address?.city}`
              : ""}
          </Heading2>
        </Box>
      </Box>

      <Divider sx={{ margin: "0 auto", width: "92%" }} />

      {workDescriptionFi && (
        <>
          <Box sx={{ padding: "0px 0px 16px 16px" }}>
            <Heading1>{t("order:previewWorkDescriptionTitle")}</Heading1>
            <Text1 variant="body2" paragraph>
              {workDescriptionFi}
            </Text1>
          </Box>

          <Divider sx={{ margin: "0 auto", width: "92%" }} />
        </>
      )}

      {longWorkTimeDescriptionFi && (
        <>
          <Box sx={{ padding: "0px 0px 16px 16px" }}>
            <Heading1>{t("order:previewWorkTimeTitle")}</Heading1>
            <Text1>{longWorkTimeDescriptionFi}</Text1>
          </Box>

          <Divider sx={{ margin: "0 auto", width: "92%" }} />
        </>
      )}

      <Box sx={{ padding: "0px 0px 16px 16px" }}>
        <Heading1>{t("order:previewWorkAgreementTitle")}</Heading1>
        <Text1 sx={{ paddingBottom: "10px" }}>
          {t("order:previewWorkAgreementDescription")}
        </Text1>
        <Text2 sx={{ paddingBottom: "2px" }}>
          <strong>{t("common:employer")}:</strong> {"Eezy Yhtiö Oy"}
        </Text2>
        <Text2 sx={{ paddingBottom: "2px" }}>
          <strong>{t("order:tesContract")}:</strong> {tesName}
        </Text2>
        {type === "Fixed-term" && (
          <Text2 sx={{ paddingBottom: "2px" }}>
            <strong>{t("order:reasonForTemporaryEmployment")}:</strong>{" "}
            {t("order:" + reasonForTemporaryEmployment)}
          </Text2>
        )}
      </Box>
    </>
  );
}

export default Details;
